<template>
	<div class="bodywrap">
		<div class="bannerwrap clearfix">
			<img class="fl" :src="commmonWebConfig.webCommonUtils+'/img/mapply/customize/banner.png'" alt="" />
		</div>
<div class="serverBig clearfix">
		<div class="serverwrap clearfix">
			<div class="textLeft fl">
				<div class="iconwrap toBotton clearfix"><em class="icon01"></em><span>一对一帮买专家服务</span></div>
				<div class="iconwrap clearfix"><em class="icon01"></em><span>专业购车建议</span></div>
			</div>
			<div class="textRight fl">
				<div class="iconwrap toBotton clearfix"><em class="icon01"></em><span>全城实时精准比价</span></div>
				<div class="iconwrap clearfix"><em class="icon01"></em><span>正规4S店合作</span></div>
			</div>
		</div>
</div>
		<div class="pathwrap">
			<ul class="clearfix">
				<li>
					<em class="icon01"></em>
					<p>填写信息</p>
				</li>
				<span class="arror"></span>
				<li>
					<em class="icon02"></em>
					<p>专业团长服务</p>
				</li>
				<span class="arror"></span>
				<li>
					<em class="icon03"></em>
					<p>放心选好车</p>
				</li>
			</ul>
		</div>
		<div class="carmsgbigcolor">
			<div class="carmsgwrap">
				<div class="carmsgtit">
					<div class="tit-textTop">您的购车信息</div>
					<div class="tit-text">方便我们的团长了解您，同时节省您的时间</div>
				</div>
				<div class="checkboxwrap clearfix">
					<div class="checkboxlist clearfix" v-for="(item,index) in tcPcOptionsList">
						<label class="checktit">{{item.title}}</label>
						<ul class="clearfix">
							<li :class="[{'activeColor':itemValue.active}]" v-for="(itemValue,indexValue) in item.tcPcOptionsValueList" @click="selects(index,indexValue)">{{itemValue.optValus}}</li>
						</ul>
					</div>
					<div class="otherneed">
						<label class="othertit">其他购车需求（选填）</label>
						<textarea v-model="other" class="othertext" placeholder="请填写您的购车需求"></textarea>
					</div>
				</div>
			</div>
			<div class="submitBtn" @click="submitBtn">提交</div>
			 <div class="addxyroom">*请放心填写,报名即视为同意<a href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a> </div>
			<agreementComponent></agreementComponent>
			<div class="popUp" v-show="isLading"></div>
		</div>

	</div>
</template>
<style type="text/css" lang="less" scoped>
</style>
<script type="text/javascript">
	import { Toast } from 'mint-ui';
	export default {
		name: 'index',
		data() {
			return {
				other: '',
				isLading: false,
				tcPcOptionsList: []
			}
		},
		beforeCreate: function() {
			document.title = "团车私车定制";
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/customize/index.css"
			});

		},
		mounted: function() {
			var self = this;
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
			/***统计添加**/
			!function(e, t, n, g, i) {
			    e[i] = e[i] || function() { 
			    	(e[i].q = e[i].q || []).push(arguments)
			    };
			    var n = t.createElement("script");
			    var tag = t.getElementsByTagName("script")[0];
			    n.async = 1;
			    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
			    tag.parentNode.insertBefore(n, tag);
			} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
		},
		methods: {
			selects: function(index, itemIndex) {
				var self = this;
				var optionCounts = this.tcPcOptionsList[index].multiSelect; //控制选几项
				if(optionCounts == 0) {
					for(var optionIndex in self.tcPcOptionsList[index].tcPcOptionsValueList) {
						self.$set(self.tcPcOptionsList[index].tcPcOptionsValueList[optionIndex], "active", false)
						self.tcPcOptionsList[index].tcPcOptionsValueList[optionIndex].active = false;
					}
				} else {
					var count = 0;
					for(var optionIndex in self.tcPcOptionsList[index].tcPcOptionsValueList) {
						if(self.tcPcOptionsList[index].tcPcOptionsValueList[optionIndex].active && itemIndex != optionIndex) {
							count++;
						}
					}
					if(count >= optionCounts) {
						return;
					}
				}
				var optionObj = this.tcPcOptionsList[index].tcPcOptionsValueList[itemIndex];
				optionObj.active = !optionObj.active;
				this.tcPcOptionsList[index].tcPcOptionsValueList[itemIndex] = optionObj;
			},
			webReady: function() {
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + '/' + 'privatecar' + self.ajaxSubmit.allUrl.addApplyData,
					type: 'post',
					dataType: 'json',
					data: {},
					success: function(data) {
						if(data.responseHeader.status == 200) {
							console.log(data);
							self.tcPcOptionsList = data.response.result.tcPcOptionsList;
							for(var index in self.tcPcOptionsList) {
								for(var itemIndex in self.tcPcOptionsList[index].tcPcOptionsValueList) {
									self.$set(self.tcPcOptionsList[index].tcPcOptionsValueList[itemIndex], "active", false);
								}
							}
							console.log(self.tcPcOptionsList);
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
					}
				});
			},
			addxydetail: function() {
				// $(".xymarsk").show();
				// $(".addxypop-mark").show();
				// $('html').css({
				// 	"overflow-y": "hidden"
				// });
				// $('body', 'html').css({
				// 	"position": "fixed",
				// 	"left": "50%",
				// 	"margin-left": "-5rem",
				// 	"top": 0
				// });
      			agreementUtil.agreement.init();

	    	},
			submitBtn: function() { //提交
				var self = this;
				var param = {};
				var paramIndex = 0;
				for(var index in self.tcPcOptionsList) {
					var count = 0;
					for(var itemIndex in self.tcPcOptionsList[index].tcPcOptionsValueList) {
						if(self.tcPcOptionsList[index].tcPcOptionsValueList[itemIndex].active) {
							count++;
							param["tcPcApplyCustomList[" + paramIndex + "].applyId"] = self.$route.query.applyId;
							param["tcPcApplyCustomList[" + paramIndex + "].optionId"] = self.tcPcOptionsList[index].tcPcOptionsValueList[itemIndex].optionId;
							param["tcPcApplyCustomList[" + paramIndex + "].optionValueId"] = self.tcPcOptionsList[index].tcPcOptionsValueList[itemIndex].id;
							paramIndex++;
						}
					}
					if(count <= 0) {
						Toast({
							message: "请选择" + self.tcPcOptionsList[index].title,
							position: 'middle',
							duration: 2000
						});
						return;
					}

				}
				param['otherDemand'] = self.other;
				self.isLading = true;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + '/' + 'privatecar' + self.ajaxSubmit.allUrl.addApplyCustom,
					type: 'post',
					data: param,
					success: function(data) {
						if(data.responseHeader.status == 200) {
							console.log(data);
							//跳转成功页面
							// self.$router.push({
							// 	path: "/hmtcj/suc?applyId=" + self.$route.query.applyId + "&periodsId=" + self.$route.query.periodsId + "&t=" + Date.parse(new Date());
							// });
							window.location.href = "/hmtcj/suc?applyId=" + self.$route.query.applyId + "&periodsId=" + self.$route.query.periodsId + "&t=" + Date.parse(new Date());
						} else {
							self.isLading = false;
							console.log('请求失败');
						}
					},
					error: function() {
						self.isLading = false;
						console.log('error');
					}

				});

			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/views/customize/index.vue